export function getItemNodeFormatting(heading, values) {
    var formatter = function (value) {
        if (value !== null && value !== undefined && heading.formatter) {
            return heading.formatter(value);
        }
        return value;
    };
    return formatter(values[heading.key]);
}
export function getItemStringFormatting(heading, values) {
    var formatter = function (value) {
        if (value !== null && value !== undefined && heading.tipFormatter) {
            return heading.tipFormatter(value);
        }
        return value;
    };
    return "".concat(formatter(values[heading.key]));
}
export function getDataTestId(heading, rowId) {
    return heading.dataTestId && "".concat(heading.dataTestId, "-").concat(rowId);
}
export var getCellId = function (id, rowId) {
    return id && "".concat(id, "__rowId-").concat(rowId);
};
export var getCellDataTestId = function (rowIndex, dataTestId) {
    return dataTestId && "".concat(dataTestId, "-row-").concat(rowIndex, "-col-");
};
export var getCellDataId = function (rowIndex, dataId) {
    return dataId && "".concat(dataId, "-row-").concat(rowIndex, "-col-");
};
export var getHiddenClassesFromBreakpoints = function (points) { var _a; return (_a = points === null || points === void 0 ? void 0 : points.reduce(function (css, point) { return "".concat(css, " hidden-").concat(point); }, "")) !== null && _a !== void 0 ? _a : ""; };
export var getTableColumnWidth = function (width) {
    return width ? "table__column ".concat(getColumnWidthClassName(width)) : "";
};
export var getColumnWidthClassName = function (width) {
    return "column-width--".concat(width);
};
